module.exports = __webpack_public_path__ + "img/global-lb.607640ed.png";